import LocationActions from 'actions/Location'
import NotificationActions from 'actions/Notification'
import SectorActions from 'actions/Sector'
import VariableActions from 'actions/Variable'
import ActionStatus from 'components/ActionStatus'
import { HeaderNotifications } from 'pages/Notifications/Header'
import LeftSideV2 from 'pages/Notifications/LeftSideV2'
import { NavItems } from 'pages/Notifications/Nav'
import RightSide from 'pages/Notifications/RightSide'
import { REDUX } from 'constants/'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Dispatch } from 'redux'
import NotificationService from 'services/Notification'
import store from 'store'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import { LocationAction, LocationReducer } from 'types/location'
import { NotificationAction, NotificationReducer } from 'types/notification'
import { SectorAction, SectorReducer } from 'types/sector'
import { VariableAction, VariableReducer } from 'types/variable'
import { DAMAGE_LEVELS } from 'utils/damage'
import { NotifyContainer, NotifyContent, NotifyMain } from './styles'
import { TopHeaderNotifications } from 'pages/Notifications/TopHeader'
import { GroupTreatmentModal } from 'components/Modals/GroupTreatment'
import { GroupAssumeTreatmentModal } from 'components/Modals/GroupAssumeTreatment'
import { GroupTreatmentFailureModal } from 'components/Modals/GroupTreatmentFailure'
import { featureFlags } from 'config/featureFlags'
import { findNavbarItemBySubState, mapSubStateToBackend } from 'constants/notificationSubState'
import { buildNavbarItems } from 'pages/Notifications/buildNavbarItems'

const Notifications = () => {
    const navigate = useNavigate()

    const [currentNav, setCurrentNav] = useState<NavItems>()
    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const sectorSelector: SectorReducer = useSelector(
        (state: RootReducerState) => state.sectorReducers
    )
    const locationSelector: LocationReducer = useSelector(
        (state: RootReducerState) => state.locationReducers
    )
    const variableSelector: VariableReducer = useSelector(
        (state: RootReducerState) => state.variableReducers
    )

    const location = useLocation()
    const { handleSubmit, control, watch, setValue, getValues } = useForm()

    const [statusEdit, setStatusEdit] = useState(false)
    const [allSectors, setAllSectors] = useState([])
    const [tabNavItems, setTabNavItems] = useState<NavItems[]>([])
    const [currentTabNavItem, setCurrentTabNavItem] =
        useState<NavItems>(undefined)

    const [isEnabledLocationFilter, setEnabledLocationFilter] =
        useState<boolean>(false)
    const [isEnabledSectorFilter, setEnabledSectorFilter] =
        useState<boolean>(false)
    const [currentNotificationSelected, setCurrentNotificationSelected] =
        useState<NavItems | any>(undefined)
    const [notificationsList, setNotificationsList] = useState<any>([])
    const [paginationItensByPage, setPaginationItensByPage] =
        useState<number>(10)

    const [searchValue, setSearchValue] = useState<string>()
    const hasTriggeredReloadForEmptyList = useRef(false)
    // Ref para rastrear se já foi feita a navegação inicial após pesquisa (para não forçar volta para "Todas")
    const hasNavigatedAfterSearch = useRef(false)
    const lastSearchValue = useRef<string>('')
    const lastNotificationsCount = useRef<number>(0)
    const lastSubmittedSearchRef = useRef<string | undefined>(undefined)
    const skipBlurSearchAfterEnterRef = useRef(false)
    const skipReloadOnNavSyncRef = useRef(false)
    const applyingSearchSubStateRef = useRef(false)
    
    // Group Treatment Modal state
    const [isGroupTreatmentModalOpen, setIsGroupTreatmentModalOpen] = useState(false)
    const [isGroupAssumeTreatmentModalOpen, setIsGroupAssumeTreatmentModalOpen] = useState(false)
    const [isGroupTreatmentFailureModalOpen, setIsGroupTreatmentFailureModalOpen] = useState(false)
    const [isGroupTreatmentFailurePartialModalOpen, setIsGroupTreatmentFailurePartialModalOpen] = useState(false)
    const [failureNotificationStatus, setFailureNotificationStatus] = useState<string>('2')
    const [failedNotifications, setFailedNotifications] = useState<any[]>([])
    const [groupCount, setGroupCount] = useState(0)

    const INDEX_INITIAL_PAGINATION = `0`

    const notificationDispatch: Dispatch<NotificationAction> = useDispatch()
    const locationDispatch: Dispatch<LocationAction> = useDispatch()
    const sectorDispatch: Dispatch<SectorAction> = useDispatch()
    const variableDispatch: Dispatch<VariableAction> = useDispatch()

    useEffect(() => {
        if (location.pathname === `/notificacoes`) {
            console.log(`[${new Date().toISOString()}] Carregamento da tela listagem das Notificações foi iniciado.`);

            const uUserType = getValues('u_user_type')
            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unityValue],
                sectorValue,
                damageLevel,
                order,
                searchValue,
                subState,
                uUserType
            )
        }
    }, [auth?.dataJwt])

    const unityValue = watch('unity')
    const sectorValue: [] = watch('sector')
    const order = watch('order')
    const damageLevel: [] = watch('damageLevel')
    const subState = watch('subState')
    const uUserType = watch('u_user_type')

    const submitSearchFromInput = (term: string) => {
        const normalizedTerm = term ?? ''
        if (normalizedTerm === lastSubmittedSearchRef.current) {
            return
        }
        lastSubmittedSearchRef.current = normalizedTerm

        if (normalizedTerm !== lastSearchValue.current) {
            hasNavigatedAfterSearch.current = false
            lastSearchValue.current = normalizedTerm
        }

        const uUserType = getValues('u_user_type')
        reloadNotificationData(
            auth?.dataJwt?.profile,
            auth?.dataJwt?.location,
            INDEX_INITIAL_PAGINATION,
            [unityValue],
            sectorValue,
            damageLevel,
            order,
            normalizedTerm,
            subState,
            uUserType
        )
    }

    /**
     * Evento que dispara a busca por algum termo (Enter ou blur, sem duplicar Enter + blur)
     * @param event
     */
    const handleFilterWithSearch = (event) => {
        const term = event.target.value

        if (event.type === 'keyup' && event.key === 'Enter') {
            skipBlurSearchAfterEnterRef.current = true
            submitSearchFromInput(term)
            event.target.blur()
            setSearchValue(term)
            return
        }

        if (event.type === 'blur') {
            if (skipBlurSearchAfterEnterRef.current) {
                skipBlurSearchAfterEnterRef.current = false
                setSearchValue(term)
                return
            }
            submitSearchFromInput(term)
            setSearchValue(term)
            return
        }

        setSearchValue(term)
    }

    /**
     * Utilizado na listagem de notificações no evento de click para selecionar uma notificação para pré-visualização
     * @param index
     */
    const setSelectedNotification = (index: number) => {
        NotificationActions.setProgressBarNavClicked(notificationDispatch, false)
        let newListNotifications = [...notificationsList]
        newListNotifications.forEach(
            (notification) => (notification.selected = false)
        )
        newListNotifications[index].selected = true
        NotificationActions.selectCurrentNotification(
            notificationDispatch,
            newListNotifications[index]
        )
        setNotificationsList(newListNotifications)
    }

    /**
     * Utilizado no evento de click da paginação
     * @param index
     */
    const paginationNumberSelectedPage = (offset: string) => {
        const uUserType = getValues('u_user_type')
        reloadNotificationData(
            auth?.dataJwt?.profile,
            auth?.dataJwt?.location,
            offset,
            [unityValue],
            sectorValue,
            damageLevel,
            order,
            searchValue,
            subState,
            uUserType
        )
    }
    /**
     * Utilizado para apagar notificação selecionada no redux
     * @param index
     */
    const clearPreviewNotification = useCallback(() => {
        NotificationActions.selectCurrentNotification(
            notificationDispatch,
            undefined
        )
    }, [])
    /**
     * Recarrega a lista de notificações e seu contadores baseados no filtro aplicado.
     * @param offset
     */
    const reloadNotificationData = useCallback((
        profile: string,
        userLocationId: string,
        offset: string,
        locations: any[],
        sectors: [],
        damageLevel: [],
        order: any,
        searchValue: string,
        subState?: string,
        uUserType?: string | null
    ) => {
        // Verifica se há pesquisa ativa
        const hasActiveSearch = searchValue && searchValue.trim() !== '' && searchValue !== 'null'
        
        // Atualizar o lastSearchValue com o valor que está sendo usado na chamada da API
        // Isso garante que quando os resultados chegarem, saberemos qual pesquisa foi feita
        const searchValueForApi = searchValue || ''
        if (searchValueForApi !== lastSearchValue.current) {
            hasNavigatedAfterSearch.current = false
            lastSearchValue.current = searchValueForApi
            lastNotificationsCount.current = 0
        }
        
        // Usar a aba atual (se o usuário mudou de aba, usar a aba selecionada)
        // Se há pesquisa e não há aba selecionada, usar "Todas" (id 8) para buscar em todas as abas
        let currentNavId = notificationSelector.currentNavItem
            ? notificationSelector.currentNavItem.id
            : ['location_manager'].includes(profile)
                ? 2
                : 1
        
        // Se há pesquisa mas não há aba selecionada ainda, usar "Todas" para a primeira busca
        // Mas se o usuário já selecionou uma aba, usar a aba selecionada
        if (hasActiveSearch && !notificationSelector.currentNavItem) {
            currentNavId = 8 // Todas
        }
        
        const locationsId = locations && locations.length > 0 ? locations.join(',') : '';
        const damageLevelId = damageLevel && damageLevel.length > 0 ? damageLevel.join(';') : '';
        
        // Converte o subState se ele ainda não estiver no formato do banco (fallback)
        const convertedSubState = subState && typeof subState === 'string' && !subState.startsWith('u_finalizada_')
            ? mapSubStateToBackend(subState) || undefined
            : (typeof subState === 'string' ? subState : undefined)
        
        NotificationActions.getAllNotifications({
            dispatch: notificationDispatch,
            profile,
            userLocationId: userLocationId,
            offset,
            limit: paginationItensByPage.toString(),
            state: currentNavId,
            location: locationsId,
            sector: sectors,
            search: searchValue === `` ? `null` : searchValue,
            damageLevel: damageLevelId,
            order,
            subState: convertedSubState,
            uUserType: uUserType || null
        })
    }, [notificationDispatch, notificationSelector.currentNavItem, paginationItensByPage, order, damageLevel])
    /**
     * Check if did come from encaminhado
     */
    useEffect(() => {
        if (location.state?.encaminhado) {
            setStatusEdit(true)
            setTimeout(() => {
                setStatusEdit(false)
            }, 3000)
        }
        // Verificar se veio de reabertura
        if (location.state?.reaberta) {
            setStatusEdit(true)
            setTimeout(() => {
                setStatusEdit(false)
                // Redirecionar para a tela principal após a tarja desaparecer
                navigate('/notificacoes', { replace: true })
            }, 3000)
        }
    }, [location, navigate])
    /**
     * Escuta o evento on click em cada aba para filtrar notificações pelo status
     * Obs: esse está sendo disparado primeiro por causa da seleção da primeira aba
     */

    useEffect(() => {
        if (skipReloadOnNavSyncRef.current) {
            skipReloadOnNavSyncRef.current = false
            return
        }

        clearPreviewNotification()
        // Só recarrega se realmente mudou de aba
        if (currentTabNavItem &&
            notificationSelector.currentNavItem &&
            currentTabNavItem.id !== notificationSelector.currentNavItem.id) {
            // Verifica se há pesquisa ativa
            const hasActiveSearch = searchValue && searchValue.trim() !== '' && searchValue !== 'null'
            
            // Marcar que o usuário mudou de aba manualmente (não forçar volta para "Todas")
            if (hasActiveSearch) {
                hasNavigatedAfterSearch.current = true
            }
            
            // Se não estiver na aba de Finalizados (id 5), reseta o subState
            const shouldResetSubState = notificationSelector.currentNavItem.id !== 5
            const currentSubState = shouldResetSubState ? undefined : subState
            
            if (shouldResetSubState) {
                setValue('subState', '')
            }
            
            const uUserType = getValues('u_user_type')
            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unityValue],
                sectorValue,
                damageLevel,
                order,
                searchValue,
                currentSubState,
                uUserType
            )
        }
    }, [notificationSelector.currentNavItem, currentTabNavItem])


    /**
     * Evento que preenche a listagem principal de notificação para o compoenente <RightSide/>
     */
    useEffect(() => {
        setNotificationsList(notificationSelector.notificationsList)
    }, [notificationSelector.notificationsList])

    /**
     * Atualiza o currentNav quando houver filtro de subState e a resposta do backend chegar
     */
    useEffect(() => {
        if (currentNav?.id === 5 && subState && subState !== '' && notificationSelector.notificationScreen?.navbar) {
            const finishedNavItem = findNavbarItemBySubState(notificationSelector.notificationScreen.navbar, 5, subState)
            
            if (finishedNavItem && finishedNavItem.number && currentNav.number !== finishedNavItem.number) {
                setCurrentNav({
                    ...currentNav,
                    number: finishedNavItem.number
                })
            }
        }
    }, [notificationSelector.notificationScreen, subState, currentNav?.id])

    /**
     * Escuta o evento on que preenche os dados da barra de navegação de acordo com o perfil
     */
    useEffect(() => {
        let screen = notificationSelector.notificationScreen
        if (!screen) return

        let navbarToSet = buildNavbarItems(screen.navbar, subState)
        const finalizadaItemToShow = navbarToSet.find((item: any) => item && item.id === 5) || null
        
        // Verifica se há pesquisa ativa
        const hasActiveSearch = searchValue && searchValue.trim() !== '' && searchValue !== 'null'
        
        // Verifica se há filtros de hospital, setor, tipo de usuário ou sub status aplicados
        const hasLocationFilter = unityValue && (Array.isArray(unityValue) ? unityValue.length > 0 : unityValue !== '')
        const hasSectorFilter = sectorValue && Array.isArray(sectorValue) && sectorValue.length > 0
        const hasUserTypeFilter = uUserType && uUserType !== null && uUserType !== ''
        const hasSubStateFilter = subState && subState !== '' && subState !== 'null'
        const hasActiveFilters = hasLocationFilter || hasSectorFilter || hasUserTypeFilter || hasSubStateFilter
        
        // Resetar flag de navegação se o valor da pesquisa mudou (nova pesquisa ou pesquisa limpa)
        // Mas só resetar se realmente mudou (não resetar se for o mesmo valor)
        const currentSearchValue = searchValue || ''
        if (currentSearchValue !== lastSearchValue.current) {
            hasNavigatedAfterSearch.current = false
            lastSearchValue.current = currentSearchValue
            lastNotificationsCount.current = 0
        }
        
        setTabNavItems(navbarToSet)
        setEnabledLocationFilter(screen && screen.select_location?.enabled)
        setEnabledSectorFilter(screen && screen.select_sector?.enabled)

        let currentNavId = notificationSelector.currentNavItem
            ? notificationSelector.currentNavItem.id
            : ['location_manager'].includes(auth?.dataJwt?.profile)
                ? 2
                : 1

        const isEmptyList = !notificationSelector?.notificationScreen?.list_notifications || 
                           notificationSelector?.notificationScreen?.list_notifications?.length === 0
        const hasCounts = screen.navbar?.length > 0 && 
                         screen.navbar.some((i) => parseInt(i?.number) > 0)

        // Se a lista está vazia mas há contagens, encontrar aba com notificações
        // MAS não mudar se o usuário estiver na aba de Finalizados (id 5)
        const isOnFinishedTab = notificationSelector.currentNavItem?.id === 5
        const isOnFinishedTabFiltering = notificationSelector.currentNavItem?.id === 5 && subState && subState !== ''
        
        // PRIORIDADE 1: Se há pesquisa ativa e há resultados, determinar a aba baseado no estado da primeira notificação
        // Se houver apenas 1 notificação, ir para a aba correspondente ao status dela
        // Se houver mais de 1 notificação, ir para a aba "Todas" (id 8)
        // MAS só fazer isso se ainda não foi feita a navegação inicial (permitir que usuário mude de aba depois)
        let currNav: any = null
        let shouldUseSearchNavigation = false
        
        if (hasActiveSearch && !isEmptyList && notificationSelector?.notificationScreen?.list_notifications?.length > 0) {
            const notificationsCount = notificationSelector.notificationScreen.list_notifications.length
            
            // Só forçar navegação se ainda não foi feita a navegação inicial após esta pesquisa específica
            // O lastSearchValue.current já foi atualizado no reloadNotificationData com o valor correto
            // Verificar se o searchValue atual corresponde ao lastSearchValue (garantir que é a mesma pesquisa)
            const currentSearchValue = searchValue || ''
            const isSameSearch = currentSearchValue === lastSearchValue.current
            
            // Se não é a mesma pesquisa, resetar o flag (pode acontecer se o estado ainda não foi atualizado)
            if (!isSameSearch) {
                hasNavigatedAfterSearch.current = false
                lastSearchValue.current = currentSearchValue
                lastNotificationsCount.current = 0
            }
            
            // Se a quantidade de notificações mudou de mais de 1 para 1, resetar o flag para permitir navegação
            // Isso é importante porque quando há mais de 1 notificação, vai para "Todas", mas depois quando filtra
            // e fica apenas 1, precisa navegar para a aba correta
            if (lastNotificationsCount.current > 1 && notificationsCount === 1) {
                hasNavigatedAfterSearch.current = false
            }
            
            // Atualizar a última quantidade de notificações
            lastNotificationsCount.current = notificationsCount
            
            // Só forçar navegação se ainda não foi feita a navegação inicial
            if (!hasNavigatedAfterSearch.current) {
                shouldUseSearchNavigation = true
                
                if (notificationsCount === 1) {
                    // Há apenas 1 notificação: ir para a aba correspondente ao status dela
                    const firstNotification = notificationSelector.notificationScreen.list_notifications[0]
                    const notificationState = firstNotification?.u_state?.value
                    
                    if (notificationState) {
                        // O u_state.value já é o ID da aba (1, 2, 3, 4, 5, 6)
                        const targetNavId = parseInt(notificationState)
                        
                        if (targetNavId && targetNavId >= 1 && targetNavId <= 6) {
                            currentNavId = targetNavId
                            
                            // Se for a aba de Finalizadas (id 5) e a notificação tiver u_sub_state, setar no select
                            if (targetNavId === 5) {
                                const notificationSubState = firstNotification?.u_sub_state?.value || firstNotification?.u_sub_state
                                if (notificationSubState) {
                                    // O valor já vem no formato do backend (u_finalizada_com_tratativa ou u_finalizada_sem_tratativa)
                                    // que é o mesmo formato usado no enum NotificationSubStatus
                                    applyingSearchSubStateRef.current = true
                                    setValue('subState', notificationSubState)
                                }
                            }
                            
                            // Buscar a aba correspondente na navbar original primeiro (mais confiável)
                            if (screen && screen.navbar) {
                                currNav = screen.navbar.find((i: any) => i && i.id === targetNavId && !i?.u_sub_state) || 
                                          screen.navbar.find((i: any) => i && i.id === targetNavId)
                            }
                            
                            // Se não encontrou na original, buscar na filtrada
                            if (!currNav) {
                                currNav = navbarToSet.find((i: any) => i && i.id === targetNavId) || null
                            }
                            
                            // Se ainda não encontrou, criar um objeto básico para garantir que temos algo
                            if (!currNav) {
                                currNav = {
                                    id: targetNavId,
                                    number: '1',
                                    label: `Aba ${targetNavId}`
                                }
                            }
                            
                            // Marcar que já foi feita a navegação inicial para esta pesquisa
                            hasNavigatedAfterSearch.current = true
                        }
                    }
                } else {
                    // Há mais de 1 notificação: ir para a aba "Todas" (id 8)
                    currentNavId = 8
                    currNav = navbarToSet.find((i: any) => i && i.id === 8) || null
                    
                    // Se não encontrou na navbar filtrada, buscar na original
                    if (!currNav && screen && screen.navbar) {
                        currNav = screen.navbar.find((i: any) => i && i.id === 8)
                    }
                    
                    // Marcar que já foi feita a navegação inicial para esta pesquisa
                    hasNavigatedAfterSearch.current = true
                }
            }
        } else if (hasActiveSearch && isEmptyList && !hasNavigatedAfterSearch.current) {
            // Se há pesquisa ativa mas não há resultados, manter na aba "Todas" (só na primeira vez)
            shouldUseSearchNavigation = true
            currentNavId = 8
            currNav = navbarToSet.find((i: any) => i && i.id === 8) || null
            
            if (!currNav && screen && screen.navbar) {
                currNav = screen.navbar.find((i: any) => i && i.id === 8)
            }
            
            hasNavigatedAfterSearch.current = true
        }
        
        // PRIORIDADE 2: Lógica normal (só executa se não usou navegação de pesquisa)
        if (!shouldUseSearchNavigation) {
            // Não mudar de aba se estiver na aba de Finalizados (com ou sem filtro)
            // Também não mudar se houver filtros de hospital/setor ativos (manter na aba atual mesmo que vazia)
            if (isEmptyList && hasCounts && !isOnFinishedTab && !hasActiveFilters) {
                const navWithNotifications = screen.navbar.find((i) => parseInt(i?.number) > 0)
                if (navWithNotifications) {
                    currentNavId = navWithNotifications.id
                }
            }
            
            // Se estiver na aba de Finalizados, manter o currentNavId como 5
            if (isOnFinishedTab) {
                currentNavId = 5
            }

            // Se estiver na aba de Finalizados com filtro de subState, buscar o item correto usando o u_sub_state
            if (isOnFinishedTabFiltering) {
                // Buscar o item com o u_sub_state correspondente ao filtro na navbar original
                // (porque navbarToSet ainda não tem os itens de Finalizados adicionados)
                currNav = findNavbarItemBySubState(screen.navbar, 5, subState)
                
                // Se não encontrou, criar um item com número 0 para o filtro aplicado
                if (!currNav) {
                    // Buscar o item de Finalizados que foi preparado para exibição
                    const baseItem = finalizadaItemToShow || navbarToSet.find((i: any) => i && i.id === 5) || 
                                    screen.navbar.find((i: any) => i && i.id === 5 && !i?.u_sub_state)
                    
                    // Criar um novo item com número 0 para o filtro aplicado
                    currNav = baseItem ? {
                        ...baseItem,
                        number: '0',
                        u_sub_state: mapSubStateToBackend(subState)
                    } : null
                }
            } else {
                // Caso normal: buscar o item pelo ID na navbar filtrada
                currNav = navbarToSet.find((i: any) => i && currentNavId == i?.id) || null
                
                // Se não encontrou na navbar filtrada, buscar na original como fallback
                if (!currNav && screen && screen.navbar) {
                    currNav = screen.navbar.find((i: any) => i && currentNavId == i?.id && !i?.u_sub_state) || 
                              screen.navbar.find((i: any) => i && currentNavId == i?.id)
                }
            }
            
            // Se estiver na aba de Finalizados e voltou para "todos", manter a aba de Finalizados ativa
            // Mas não fazer isso se houver pesquisa ativa (a pesquisa deve manter a aba atual)
            if (!subState && !hasActiveSearch && notificationSelector.currentNavItem?.id === 5 && currNav && currNav.id === 5) {
                currentNavId = 5
                // Usar o item de Finalizados que foi preparado para exibição (sem u_sub_state)
                currNav = finalizadaItemToShow || navbarToSet.find((i: any) => i && i.id === 5) || currNav
            }
        }
        
        // Atualiza o Redux quando:
        // 1. Usou navegação de pesquisa (sempre atualizar quando navegação de pesquisa foi aplicada)
        // 2. Há pesquisa ativa mas já foi feita navegação inicial e a aba mudou (usuário mudou manualmente)
        // 3. Não há pesquisa ativa e a aba mudou (comportamento normal)
        // Não atualiza se estiver filtrando por subState na aba de Finalizados (exceto quando há pesquisa ativa)
        if (currNav) {
            if (shouldUseSearchNavigation) {
                // Lista já veio na busca em "Todas"; só sincroniza aba/substatus sem nova requisição
                skipReloadOnNavSyncRef.current = true
                setCurrentTabNavItem(currNav)
                NotificationActions.setCurrentNavItem(notificationDispatch, currNav)
                applyingSearchSubStateRef.current = false
            } else if (hasActiveSearch && hasNavigatedAfterSearch.current && (!notificationSelector.currentNavItem || notificationSelector.currentNavItem.id !== currNav.id)) {
                // Usuário mudou de aba manualmente durante pesquisa
                NotificationActions.setCurrentNavItem(notificationDispatch, currNav)
            } else if (!hasActiveSearch && !isOnFinishedTabFiltering && (!notificationSelector.currentNavItem || notificationSelector.currentNavItem.id !== currNav.id)) {
                // Comportamento normal (sem pesquisa)
                NotificationActions.setCurrentNavItem(notificationDispatch, currNav)
            }
        }
        
        // Se estiver na aba de Finalizados com filtro de subState, atualizar o número do currentNav
        // com o número filtrado que vem do backend
        if (currNav && (!currentNav || currentNav.id !== currNav.id || currentNav.number !== currNav.number)) {
            setCurrentNav(currNav)
        }

        setNotificationsList(notificationSelector?.notificationScreen?.list_notifications)
        
        // Se a lista está vazia mas há contagens, fazer busca direta com o ID correto
        // MAS não fazer isso se o usuário estiver na aba de Finalizados filtrando por subState
        // E também não fazer quando há filtros de hospital/setor ativos (manter na aba atual mesmo que vazia)
        if (
            isEmptyList &&
            hasCounts &&
            !hasTriggeredReloadForEmptyList.current &&
            currNav &&
            auth?.dataJwt &&
            !(isOnFinishedTab && hasSubStateFilter) &&
            !hasActiveFilters
        ) {
            hasTriggeredReloadForEmptyList.current = true
            
            // Chamar getAllNotifications diretamente com o ID correto, sem depender do Redux
            // unityValue pode ser string ou array, então normalizamos para array primeiro
            const unityArray = Array.isArray(unityValue) ? unityValue : (unityValue ? [unityValue] : []);
            const locationsId = unityArray.length > 0 ? unityArray.join(',') : '';
            const sectorsId = sectorValue && sectorValue.length > 0 ? sectorValue : [];
            const damageLevelId = damageLevel && damageLevel.length > 0 ? damageLevel.join(';') : '';
            const uUserType = getValues('u_user_type')
            
            NotificationActions.getAllNotifications({
                dispatch: notificationDispatch,
                profile: auth.dataJwt.profile,
                userLocationId: auth.dataJwt.location,
                offset: INDEX_INITIAL_PAGINATION,
                limit: paginationItensByPage.toString(),
                state: currNav.id, // Usar o ID da aba correta diretamente
                location: locationsId,
                sector: sectorsId,
                search: searchValue === `` ? `null` : searchValue,
                damageLevel: damageLevelId,
                order,
                subState: subState || undefined,
                uUserType: uUserType || null
            })
        } else if (!isEmptyList) {
            // Resetar o flag quando a lista não está mais vazia
            hasTriggeredReloadForEmptyList.current = false
        }
    }, [
        notificationSelector.notificationScreen, 
        unityValue, 
        sectorValue,
        damageLevel,
        order,
        searchValue,
        subState,
        currentNav,
        auth?.dataJwt?.profile,
        auth?.dataJwt?.location,
        auth?.dataJwt,
        notificationDispatch,
        paginationItensByPage
    ])


    /**
     * Evento inicial que renderiza os dados de unidade, setor e componentes de tela
     * Configurando filtros de acordo com o perfil (ver NotificationActions.renderNotificationScreen)
     */
    useEffect(() => {
        if (auth?.dataJwt && !auth?.isAutheticated) {
            VariableActions.getAllVariables(variableDispatch)
            LocationActions.getAllLocations(locationDispatch, 'all')
            SectorActions.getAllSectors(sectorDispatch)
            SectorActions.getAllSectorsGroupedByLocationsId(sectorDispatch)
            NotificationActions.getDamageLevel(notificationDispatch)

            store.dispatch({ type: REDUX.reducers.SET_IS_AUTHENTICATED, payload: true })

            if (auth?.dataJwt?.profile === 'location_manager') {
                const location = auth?.dataJwt?.locations.sort((o1, o2) => o1.name?.localeCompare(o2.name))
                setValue('unity', location[0].sys_id)
                setValue('sector', location[0].sectors.map((sec) => sec.sys_id))
            }

            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unityValue],
                sectorValue,
                damageLevel,
                order,
                searchValue,
                subState
            )
        }
    }, [auth?.dataJwt])
    /**
     * Evento que preenche o objeto da notificação selecionada para o componente <LeftSide>
     * Obs: ver função setSelectedNotification (usada no componente <RightSide> para gravar a notificação no redux)
     */
    useEffect(() => {
        setCurrentNotificationSelected(
            notificationSelector.notificationSelected
        )
    }, [notificationSelector.notificationSelected])

    /**
     * Atualiza os setores quando uma unidade está selecionada e os dados de setores agrupados são carregados
     */
    useEffect(() => {
        const currentUnity = unityValue
        if (currentUnity && sectorSelector.sectorsGroupedByLocationId) {
            const sectorsForLocation = sectorSelector.sectorsGroupedByLocationId[currentUnity]
            
            if (sectorsForLocation && Array.isArray(sectorsForLocation) && sectorsForLocation.length > 0) {
                const secs = sectorsForLocation.map((l: { sys_id: string; u_name: string }) => ({
                    value: l.sys_id,
                    label: l.u_name
                }))
                .filter(sec => sec.value && sec.label)
                .sort((o1, o2) => o1.label?.localeCompare(o2.label))
                
                // Só atualiza se os setores forem diferentes dos atuais
                if (JSON.stringify(secs) !== JSON.stringify(allSectors)) {
                    setAllSectors(secs)
                }
            }
        } else if (!currentUnity) {
            // Limpar setores quando não há unidade selecionada
            setAllSectors([])
        }
    }, [unityValue, sectorSelector.sectorsGroupedByLocationId])



    const handleSubmitForm = () => { }
    /**
     * Recarrega as informações de notificações quando mudar o filtro de unidade
     */

    const onChangeLocation = useCallback((value = undefined) => {
        if (!value) {
            setValue('unity', '')
            setAllSectors([]) // Limpar setores quando não há unidade selecionada
            setValue('sector', []) // Limpar seleção de setores
        } else {
            // Garantir que value é uma string (pode vir como array em alguns casos)
            const locationId = Array.isArray(value) ? value[0] : value
            
            // Buscar setores da unidade selecionada
            const sectorsForLocation = sectorSelector.sectorsGroupedByLocationId?.[locationId]
            
            if (sectorsForLocation && Array.isArray(sectorsForLocation) && sectorsForLocation.length > 0) {
                const secs = sectorsForLocation.map((l) => ({
                    value: l?.sys_id,
                    label: l?.u_name
                }))
                .filter(sec => sec.value && sec.label) // Filtrar itens inválidos
                .sort((o1, o2) => o1.label?.localeCompare(o2.label))
                
                setAllSectors(secs)
            } else {
                // Se não houver setores na estrutura agrupada, limpar lista
                setAllSectors([])
            }
            
            setValue('unity', locationId)

            if (!sectorSelector.sectorsGroupedByLocationId) {
                return
            }
            
            if (auth?.dataJwt?.profile === 'location_manager') {
                let location = auth?.dataJwt?.locations.find(
                    (loc) => loc.sys_id === locationId
                )
                if (location && location.sectors) {
                    let sectors = location.sectors.map((sec) => {
                        return { u_name: sec.name, sys_id: sec.sys_id }
                    })
                    let sectorsValues = location.sectors.map(
                        (sec) => sec.sys_id
                    )
                    SectorActions.setSectors(sectorDispatch, sectors)
                    setValue('sector', sectorsValues)
                }
            }
        }


        const sector = getValues('sector')
        const locationIdForReload = Array.isArray(value) ? value[0] : value

        if (auth?.dataJwt?.profile !== 'location_manager' || (auth?.dataJwt?.profile === 'location_manager' && locationIdForReload)) {
            const subState = getValues('subState')
            const uUserType = getValues('u_user_type')
            reloadNotificationData(auth?.dataJwt?.profile, auth?.dataJwt?.location, INDEX_INITIAL_PAGINATION, [locationIdForReload], sector, damageLevel, order, searchValue, subState, uUserType)
        }
    }, [notificationSelector.currentNavItem, sectorSelector.sectorsGroupedByLocationId, auth?.dataJwt?.profile, auth?.dataJwt?.locations, sectorDispatch, getValues, setValue, reloadNotificationData, damageLevel, order, searchValue])

    /**
     * Recarrega as informações de notificações quando mudar o filtro de setor
     */
    const onChangeSector = useCallback(
        (value = []) => {
            clearPreviewNotification()
            if (!value) {
                setValue('sector', [])
            } else {
                const values = value?.map((i) => i)
                setValue('sector', values)
            }
            const unity = getValues('unity')
            const sector = getValues('sector')
            const damageLevel = getValues('damageLevel')
            const order = getValues('order')
            const subState = getValues('subState')
            const uUserType = getValues('u_user_type')

            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unity],
                sector,
                damageLevel,
                order,
                searchValue,
                subState,
                uUserType
            )

        },
        [
            INDEX_INITIAL_PAGINATION,
            auth?.dataJwt?.location,
            auth?.dataJwt?.profile,
            clearPreviewNotification,
            getValues,
            reloadNotificationData,
            searchValue,
            setValue
        ]
    )

    /**
     * Recarrega as informações de notificações quando mudar o filtro de ordem
     */
    const onChangeOrder = useCallback(
        (value = []) => {
            clearPreviewNotification()
            setValue('order', value)
            const unity = getValues('unity')
            const sector = getValues('sector')
            const damageLevel = getValues('damageLevel')
            const order = getValues('order')
            const subState = getValues('subState')
            const uUserType = getValues('u_user_type')

            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unity],
                sector,
                damageLevel,
                order,
                searchValue,
                subState,
                uUserType
            )

        },
        [
            INDEX_INITIAL_PAGINATION,
            auth?.dataJwt?.location,
            auth?.dataJwt?.profile,
            clearPreviewNotification,
            getValues,
            reloadNotificationData,
            searchValue,
            setValue
        ]
    )

    /**
     * Recarrega as informações de notificações quando mudar o filtro de grau do dano
     */
    const onChangeDamageLevel = useCallback(
        (value = []) => {
            clearPreviewNotification()
            if (!value) {
                setValue('damageLevel', [])
            } else {
                const values = value?.map((i) => i)
                setValue('damageLevel', values)
            }
            const unity = getValues('unity')
            const sector = getValues('sector')
            const order = getValues('order')
            const damageLevel = getValues('damageLevel')
            const subState = getValues('subState')
            const uUserType = getValues('u_user_type')


            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unity],
                sector,
                damageLevel,
                order,
                searchValue,
                subState,
                uUserType
            )

        },
        [
            INDEX_INITIAL_PAGINATION,
            auth?.dataJwt?.location,
            auth?.dataJwt?.profile,
            clearPreviewNotification,
            getValues,
            reloadNotificationData,
            searchValue,
            setValue
        ]
    )

    /**
     * Recarrega as informações de notificações quando mudar o filtro de sub status
     */
    const onChangeSubState = useCallback(
        (value = '') => {
            // Só processa se estiver na aba de Finalizados (id 5)
            if (!notificationSelector.currentNavItem || notificationSelector.currentNavItem.id !== 5) {
                return
            }

            if (applyingSearchSubStateRef.current) {
                applyingSearchSubStateRef.current = false
                return
            }

            clearPreviewNotification()
            setValue('subState', value)
            const unity = getValues('unity')
            const sector = getValues('sector')
            const order = getValues('order')
            const damageLevel = getValues('damageLevel')
            const uUserType = getValues('u_user_type')
            // Valida e converte o valor do enum para o formato do banco (u_finalizada_com_tratativa / u_finalizada_sem_tratativa)
            const subStateValue = value ? mapSubStateToBackend(value) || undefined : undefined

            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unity],
                sector,
                damageLevel,
                order,
                searchValue,
                subStateValue,
                uUserType
            )
        },
        [
            INDEX_INITIAL_PAGINATION,
            auth?.dataJwt?.location,
            auth?.dataJwt?.profile,
            clearPreviewNotification,
            getValues,
            reloadNotificationData,
            searchValue,
            setValue,
            notificationSelector.currentNavItem
        ]
    )

    /**
     * Recarrega as informações de notificações quando mudar o filtro de "Aberto por"
     */
    const onChangeSysCreatedBy = useCallback(
        (value = null) => {
            clearPreviewNotification()
            setValue('u_user_type', value)
            const unity = getValues('unity')
            const sector = getValues('sector')
            const order = getValues('order')
            const damageLevel = getValues('damageLevel')
            const subState = getValues('subState')

            reloadNotificationData(
                auth?.dataJwt?.profile,
                auth?.dataJwt?.location,
                INDEX_INITIAL_PAGINATION,
                [unity],
                sector,
                damageLevel,
                order,
                searchValue,
                subState,
                value
            )
        },
        [
            INDEX_INITIAL_PAGINATION,
            auth?.dataJwt?.location,
            auth?.dataJwt?.profile,
            clearPreviewNotification,
            getValues,
            reloadNotificationData,
            searchValue,
            setValue
        ]
    )

    const selectAll = ({
        name,
        options,
        isAllSelected
    }: {
        name: string
        options: any[]
        isAllSelected: boolean
    }) => {
        if (!isAllSelected) {
            setValue(name, [])
        }
        if (options && options.length > 0) {
            if (name == 'damageLevel') {
                onChangeDamageLevel([])
            }
            if (name == 'sector') {
                onChangeSector([])
            }
        }
    }

    const currentLocationList = ['nsp', 'location_qa', 'unit_general_manager', 'location_manager'].includes(auth?.dataJwt?.profile) ?
        auth?.dataJwt?.locations :
        locationSelector.locationsList

    const currentSectorList = sectorSelector.sectorsList
        ?.map((l) => ({
            value: l?.sys_id,
            label: l?.u_name
        }))
        .sort((o1, o2) => o1.label?.localeCompare(o2.label))

    let currentDamageLevelList = DAMAGE_LEVELS
        ?.map((l) => ({
            value: l?.id,
            label: l?.label,
            order: l?.order
        }))
        .sort((o1, o2) => o1.order - o2.order)

    // Group Treatment Modal handlers
    const handleShowGroupTreatmentModal = (count: number) => {
        console.log("Group Treatment Modal aberto com count:", count)
        setGroupCount(count)
        setIsGroupTreatmentModalOpen(true)
    }

    const handleCloseGroupTreatmentModal = () => {
        setIsGroupTreatmentModalOpen(false)
    }

    const handleIndividualTreatment = () => {
        setIsGroupTreatmentModalOpen(false)
        // Proceed with individual treatment - call the regular notification analyzer
        notificationAnalizer()
    }

    const handleGroupTreatment = () => {
        if (!featureFlags.groupNotifications) {
            console.warn('Feature de grupo de notificações está desabilitada')
            return
        }
        
        console.log('Seguir com o tratamento em grupo clicado!')
        setIsGroupTreatmentModalOpen(false)
        setIsGroupAssumeTreatmentModalOpen(true)
    }

    const handleCloseGroupAssumeTreatmentModal = () => {
        setIsGroupAssumeTreatmentModalOpen(false)
    }

    // Função para abrir o modal de falha parcial
    // Exemplo de uso: handleOpenGroupTreatmentFailurePartialModal('2', failedNotificationsList)
    // status: '2' para 'Aguardando' ou '3' para 'Em Tratamento'
    // notifications: array de notificações que falharam no agrupamento
    const handleOpenGroupTreatmentFailurePartialModal = (status: string, notifications: any[]) => {
        setFailureNotificationStatus(status)
        setFailedNotifications(notifications)
        setIsGroupTreatmentFailurePartialModalOpen(true)
    }

    const handleCloseGroupTreatmentFailurePartialModal = () => {
        setIsGroupTreatmentFailurePartialModalOpen(false)
    }


    const [isAssumingGroup, setIsAssumingGroup] = useState(false)

    const handleAssumeTreatment = async () => {
        if (!featureFlags.groupNotifications) {
            console.warn('Feature de grupo de notificações está desabilitada')
            return
        }
        
        console.log('Assumir tratamento em grupo clicado!')
        setIsAssumingGroup(true)
        
        // Validar se a notificação é elegível para grupo
        if (!currentNotificationSelected?.eligible_for_group_treatment) {
            console.error('Notificação não é elegível para tratamento em grupo')
            setIsGroupAssumeTreatmentModalOpen(false)
            return
        }
        
        // Verificar se já existe um grupo criado
        const hasExistingGroup = currentNotificationSelected?.u_treatment_group?.value && 
                                 currentNotificationSelected?.u_treatment_group?.value !== ''
        
        if (!hasExistingGroup) {
            try {
                // Preparar dados obrigatórios para criar o grupo na tabela x_rdsls_notificabe_treatment_groups
                // Enviando os sys_ids com os nomes corretos dos campos do ServiceNow + IDs de todas as notificações elegíveis
                const groupData = {
                    responsible: auth?.dataJwt?.sys_id || '',  // sys_id do usuário responsável
                    u_notifica_user: auth?.dataJwt?.u_user_id || auth?.dataJwt?.sys_id || '',  // u_user_id contém o ID correto
                    u_location: currentNotificationSelected?.location_incident?.value || '',  // sys_id da unidade
                    u_sector: currentNotificationSelected?.incident_sector?.value || '',      // sys_id do setor
                    u_group_damage_rating: currentNotificationSelected?.damage_level?.value || '',     // sys_id do grau de dano
                    u_incident_type: currentNotificationSelected?.u_reclassified_incident_type?.value || '', // sys_id do tipo de incidente reclassificado
                    notification_ids: currentNotificationSelected?.eligible_notification_ids?.slice(0, 50) || [] // array com sys_ids das notificações elegíveis ou lista vazia
                }
                
                console.log('Criando grupo de tratamento com dados (campos ServiceNow + notification_ids):', groupData)
                
                // Validar campos obrigatórios
                if (!groupData.responsible || !groupData.u_notifica_user || !groupData.u_location || !groupData.u_sector || 
                    !groupData.u_group_damage_rating || !groupData.u_incident_type) {
                    console.error('Campos obrigatórios faltando para criar o grupo:', groupData)
                    alert('Erro: Campos obrigatórios não encontrados para criar o grupo de tratamento')
                    setIsGroupAssumeTreatmentModalOpen(false)
                    return
                }
                
                // Criar o grupo no ServiceNow na tabela x_rdsls_notificabe_treatment_groups
                const groupResponse = await NotificationService.createTreatmentGroup(groupData)

                if (!groupResponse) {
                    throw new Error('Erro ao criar grupo: resposta vazia do servidor')
                }

                const groupData_response = groupResponse?.data?.group

                if (!groupData_response) {
                    throw new Error('Erro ao criar grupo: estrutura de resposta inválida')
                }

                if (!groupData_response.sys_id) {
                    throw new Error('Erro ao criar grupo: resposta sem sys_id')
                }

                const groupId = groupData_response.sys_id
                const groupKey = groupData_response.u_number || groupId

                // Atualizar a notificação atual com o grupo
                await NotificationService.updateNotificationGeneric(
                    { u_treatment_group: groupId },
                    currentNotificationSelected.sys_id.value
                )

                const updatedNotification = {
                    ...currentNotificationSelected,
                    u_treatment_group: {
                        value: groupId,
                        display_value: groupKey
                    }
                }

                setCurrentNotificationSelected(updatedNotification)

                NotificationActions.selectCurrentNotification(
                    notificationDispatch,
                    updatedNotification
                )

                setIsGroupAssumeTreatmentModalOpen(false)
                setIsAssumingGroup(false)

                navigate(`/notificacoes/group-treatment/${groupId}`, {
                    state: {
                        selectedNotification: updatedNotification,
                        groupKey: groupKey,
                        notificationId: updatedNotification?.sys_id?.value
                    }
                })
                return
            } catch (error) {
                console.error('Erro ao criar grupo de tratamento:', error)

                // Determinar o status atual das notificações
                const status = currentNotificationSelected?.u_state?.value || '2'
                setFailureNotificationStatus(status)

                // Verificar se o erro indica falha parcial ou total
                // Se o erro contém informações sobre notificações que falharam, é falha parcial
                // Se não, é falha total
                const errorData = error as any
                const isPartialFailure = errorData?.failedNotifications && errorData.failedNotifications.length > 0

                if (isPartialFailure) {
                    // FALHA PARCIAL: Algumas notificações foram processadas, outras falharam
                    console.log('Falha parcial detectada:', errorData.failedNotifications)

                    const notificationsThatFailed = errorData.failedNotifications.map(notification => ({
                        sys_id: { value: notification.sys_id || notification.id, display_value: notification.sys_id || notification.id },
                        number: { value: notification.number || notification.protocol, display_value: notification.number || notification.protocol },
                        incident_title: { value: notification.incident_title || notification.title, display_value: notification.incident_title || notification.title },
                        incident_description: { value: notification.incident_description || '', display_value: notification.incident_description || '' },
                        sys_created_on: { value: notification.sys_created_on || '', display_value: notification.sys_created_on || '' }
                    }))

                    setFailedNotifications(notificationsThatFailed)
                    setIsGroupTreatmentFailurePartialModalOpen(true)
                } else {
                    // FALHA TOTAL: Todas as notificações falharam
                    console.log('Falha total detectada')

                    const notificationsThatFailed = currentNotificationSelected?.eligible_notification_ids?.slice(0, 50).map(id => ({
                        sys_id: { value: id, display_value: id },
                        number: { value: id, display_value: id },
                        incident_title: { value: 'Notificação', display_value: 'Notificação' },
                        incident_description: { value: '', display_value: '' },
                        sys_created_on: { value: '', display_value: '' }
                    })) || []

                    setFailedNotifications(notificationsThatFailed)
                    setIsGroupTreatmentFailureModalOpen(true)
                }

                setIsGroupAssumeTreatmentModalOpen(false)
                setIsAssumingGroup(false)
                return
            }
        }

        const existingGroupId = currentNotificationSelected?.u_treatment_group?.value
        const existingGroupKey = currentNotificationSelected?.u_treatment_group?.display_value

        setIsGroupAssumeTreatmentModalOpen(false)
        setIsAssumingGroup(false)

        if (!existingGroupId) {
            console.error('Erro: u_treatment_group não encontrado para navegação')
            alert('Erro ao acessar o grupo de tratamento. Por favor, tente novamente.')
            return
        }

        // Navegar para a tela de tratamento em grupo
        navigate(`/notificacoes/group-treatment/${existingGroupId}`, {
            state: {
                selectedNotification: currentNotificationSelected,
                groupKey: existingGroupKey,
                notificationId: currentNotificationSelected?.sys_id?.value
            }
        })
    }

    const notificationAnalizer = () => {
        if (!currentNotificationSelected) {
            return
        }
        currentNotificationSelected.u_notification_read.display_value = "true"
        currentNotificationSelected.u_notification_read.value = "true"
        NotificationService.readerNotification(currentNotificationSelected.sys_id.value, currentNotificationSelected)
            .then((response: any) => {
                let newListNotifications = [...notificationsList]
                newListNotifications.forEach((notification) => {
                    if (notification.sys_id.value === currentNotificationSelected.sys_id.value) {
                        notification.u_notification_read = true
                    }
                })

                setNotificationsList(newListNotifications)
                navigate(`/notificacoes/${currentNotificationSelected.sys_id.value}`)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    /* Destaca o texto selecionado */
    const highlightText = (text) => {
        const regex = new RegExp(`(${searchValue})`, 'gi');
        return searchValue ?
            text.split(regex).map((part, index) =>
                part.toLowerCase() === searchValue?.toLowerCase() ? (
                    <span key={index} className="highlight">{part}</span>
                ) : part
            )
            : text
    };

    return (
        <>
            <TopHeaderNotifications
                selectAll={selectAll}
                control={control}
                currentLocationList={currentLocationList
                    ?.map((l) => ({
                        value: l?.sys_id,
                        label: l?.name
                    })).sort((o1, o2) => o1.label?.localeCompare(o2.label))}
                currentSectorList={auth?.dataJwt?.profile === 'location_manager' ? currentSectorList : (unityValue?.length ? (allSectors.length > 0 ? allSectors : []) : currentSectorList)}
                isEnabledLocationFilter={true}
                isEnabledSectorFilter={unityValue?.length}
                onChangeLocation={onChangeLocation}
                onChangeSector={onChangeSector}
            />
            <NotifyContainer>
                <NotifyMain onSubmit={handleSubmit(handleSubmitForm)}>
                    <HeaderNotifications
                        selectAll={selectAll}
                        setCurrentNav={setCurrentNav}
                        currentNav={currentNav}
                        control={control}
                        setCurrentNavItems={setCurrentTabNavItem}
                        currentLocationList={currentLocationList
                            ?.map((l) => ({
                                value: l?.sys_id,
                                label: l?.name
                            })).sort((o1, o2) => o1.label?.localeCompare(o2.label))}
                        currentSectorList={auth?.dataJwt?.profile === 'location_manager' ? currentSectorList : (unityValue?.length ? (allSectors.length > 0 ? allSectors : []) : currentSectorList)}
                        currentDamageLevelList={currentDamageLevelList}
                        notificationsList={notificationsList}
                        tabNavItems={tabNavItems}
                        isEnabledLocationFilter={true}
                        isEnabledSectorFilter={unityValue?.length}
                        handleFilterWithSearch={handleFilterWithSearch}
                        onChangeLocation={onChangeLocation}
                        onChangeSector={onChangeSector}
                        onChangeOrder={onChangeOrder}
                        onChangeDamageLevel={onChangeDamageLevel}
                        onChangeSubState={onChangeSubState}
                        onChangeSysCreatedBy={onChangeSysCreatedBy}
                        subState={subState}
                    />
                    {statusEdit && (
                        <div className="px-6 pt-2">
                            <ActionStatus
                                text={location.state?.reaberta ? "Notificação reaberta com sucesso!" : "Notificação encaminhada com sucesso!"}
                                status={1}
                            />
                        </div>
                    )}
                    
                    <NotifyContent>
                        <RightSide
                            setNotificationsList={setNotificationsList}
                            currentNotificationSelected={currentNotificationSelected}
                            damageLevelList={notificationSelector.damageLevel}
                            currentNav={
                                notificationSelector.currentNavItem
                                    ? notificationSelector.currentNavItem
                                    : currentNav
                            }
                            navItem={
                                notificationSelector.currentNavItem
                                    ? notificationSelector.currentNavItem
                                    : currentTabNavItem
                            }
                            setSelectedNotification={setSelectedNotification}
                            notificationsList={notificationsList}
                            paginationNumberSelectedPage={
                                paginationNumberSelectedPage
                            }
                            paginationItensByPage={paginationItensByPage}
                            highlightText={highlightText}
                            handleShowGroupTreatmentModal={featureFlags.groupNotifications ? handleShowGroupTreatmentModal : undefined}
                            userProfile={auth?.dataJwt?.profile}
                            subState={subState}
                            notificationScreen={notificationSelector.notificationScreen}
                        />
                        <LeftSideV2
                            isShowAnalyze={true}
                            currentNotificationSelected={
                                currentNotificationSelected
                            }
                            notificationsList={notificationsList}
                            setNotificationsList={setNotificationsList}
                            handleShowGroupTreatmentModal={featureFlags.groupNotifications ? handleShowGroupTreatmentModal : undefined}
                            userProfile={auth?.dataJwt?.profile}
                        />
                    </NotifyContent>
                </NotifyMain>
            </NotifyContainer>
            
            {featureFlags.groupNotifications && (
                <>
                    <GroupTreatmentModal
                        isOpen={isGroupTreatmentModalOpen}
                        handleCloseModal={handleCloseGroupTreatmentModal}
                        handleIndividualTreatment={handleIndividualTreatment}
                        handleGroupTreatment={handleGroupTreatment}
                        groupCount={groupCount}
                    />

                    <GroupAssumeTreatmentModal
                        isOpen={isGroupAssumeTreatmentModalOpen}
                        handleCloseModal={handleCloseGroupAssumeTreatmentModal}
                        handleAssumeTreatment={handleAssumeTreatment}
                        isLoading={isAssumingGroup}
                    />

                    <GroupTreatmentFailureModal
                        isOpen={isGroupTreatmentFailureModalOpen}
                        handleCloseModal={() => setIsGroupTreatmentFailureModalOpen(false)}
                        notificationStatus={failureNotificationStatus}
                        failureType="total"
                        affectedCount={failedNotifications.length}
                        failedNotifications={failedNotifications}
                    />

                    <GroupTreatmentFailureModal
                        isOpen={isGroupTreatmentFailurePartialModalOpen}
                        handleCloseModal={handleCloseGroupTreatmentFailurePartialModal}
                        notificationStatus={failureNotificationStatus}
                        failureType="partial"
                        affectedCount={failedNotifications.length}
                        failedNotifications={failedNotifications}
                    />
                </>
            )}
        </>
    )
}

export default Notifications

